// AgeSelector.jsx
import React, { useEffect, useState } from "react";
import { Form } from "antd";

const AgeSelector = ({ onChange, defaultValue, reset, setReset }) => {
  const [selectedAge, setSelectedAge] = useState(defaultValue || null);
  const ageOptions = ["Youth", "HS/College", "Adult"];

  const toggleAge = (age) => {
    const newSelectedAge = selectedAge === age ? null : age;
    setSelectedAge(newSelectedAge);
    if (onChange) {
      onChange(newSelectedAge);
    }
    if (setReset) setReset(false);
  };

  useEffect(() => {
    if (reset) {
      setSelectedAge(null);
    }
  }, [reset]);

  return (
    <div className="age-selector-container">
      <Form.Item label="Age (optional)" className="age-selector-title">
        <div className="age-options-container">
          {ageOptions.map((age) => (
            <div
              key={age}
              onClick={() => toggleAge(age)}
              className={`age-option ${selectedAge === age ? "selected" : ""}`}
            >
              {age}
            </div>
          ))}
        </div>
      </Form.Item>
    </div>
  );
};

export default AgeSelector;
